"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimezoneSelectorComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
const router_1 = require("@angular/router");
//INTERNAL BITS
const Moment = require("moment-timezone");
const user_service_1 = require("./user.service");
const notification_service_1 = require("./notification.service");
const loading_service_1 = require("./loading.service");
const bid_data_service_1 = require("./bid-data.service");
let TimezoneSelectorComponent = class TimezoneSelectorComponent {
    constructor(_user, _talk, _router, _loading, _bidData) {
        this._user = _user;
        this._talk = _talk;
        this._router = _router;
        this._loading = _loading;
        this._bidData = _bidData;
        this.moment = Moment(); //Create instance of moment;
        this.timezoneGroups = [];
    }
    ngOnInit() {
        this.loadSavedZone();
        this.timezoneNames = Moment.tz.names();
        allTimezones: for (let tz in this.timezoneNames) {
            let splitTz = this.timezoneNames[tz].split('/');
            if ((splitTz.length > 1) && (splitTz[1] != '')) {
                if (this.timezoneNames[tz] == this.selectedCountryZone) {
                    continue allTimezones;
                }
                for (let tzG in this.timezoneGroups) {
                    if (this.timezoneGroups[tzG].group == splitTz[0]) {
                        for (let a in this.timezoneGroups[tzG].areas) {
                            if (this.timezoneGroups[tzG].areas[a] == splitTz[1])
                                continue allTimezones;
                        }
                        this.timezoneGroups[tzG].areas.push({ displayName: splitTz[1], value: this.timezoneNames[tz] });
                        continue allTimezones;
                    }
                }
                if (splitTz[0] == 'US') {
                    this.timezoneGroups.unshift({ group: splitTz[0], areas: [{ displayName: splitTz[1], value: this.timezoneNames[tz] }] });
                }
                else {
                    this.timezoneGroups.push({ group: splitTz[0], areas: [{ displayName: splitTz[1], value: this.timezoneNames[tz] }] });
                }
            }
        }
    }
    loadSavedZone() {
        let savedZone = this._user.getTimezone();
        if (savedZone.country) {
            this.selectedCountryZone = savedZone.country;
        }
        else {
            this.selectedCountryZone = "Etc/UTC";
        }
        this.currentCountryZone = JSON.parse(JSON.stringify(this.selectedCountryZone));
    }
    onSelectedZone(selectedCountry) {
        this.selectedCountryZone = selectedCountry;
    }
    formatZoneTime(zone) {
        //Format the given zone into +00:00 format
        return this.moment.tz(zone).format('Z');
    }
    timezoneSelectorHelp() {
        this._talk.broadcast("The Dashboard is time zone is set to UTC by default. You can modify your time zone default by selecting your preferred time zone in the drop down. Upon applying the new setting, your Dashboard data will automatically update to match the time zone your preferred time zone selected.");
    }
    selectTimezone() {
        let zone = { country: this.selectedCountryZone, time: this.formatZoneTime(this.selectedCountryZone) };
        Promise.resolve(this._user.updateTimezone(zone)).then(res => {
            this._loading.start("Fetching Data...");
            this._router.navigate(['/refresh']);
            Promise.resolve(this._bidData.pull()).then(err => {
                this._loading.stop();
                this._router.navigate(['/user']);
                this._talk.broadcast(`Timezone Updated to: ${this.selectedCountryZone} (${zone.time})`);
            });
        }).catch(err => {
            this._talk.broadcast(`We had a problem updating timezone`);
        });
    }
};
exports.TimezoneSelectorComponent = TimezoneSelectorComponent;
exports.TimezoneSelectorComponent = TimezoneSelectorComponent = __decorate([
    (0, core_1.Component)({
        selector: 'timezone-selector',
        templateUrl: 'app/timezone-selector.component.html'
    }),
    __metadata("design:paramtypes", [user_service_1.UserService,
        notification_service_1.NotificationService,
        router_1.Router,
        loading_service_1.LoadingService,
        bid_data_service_1.BidDataService])
], TimezoneSelectorComponent);
//# sourceMappingURL=timezone-selector.component.js.map